import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../services/supabase';
import { logger } from '../services/logger';
import { Profile } from '../types';

export function useAdmin() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    async function checkAdminStatus() {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        
        if (!user) {
          navigate('/login');
          return;
        }

        // Directly await the full query chain
        const { data: profile, error: profileError } = await supabase
          .from('profiles')
          .select('role')
          .eq('id', user.id)
          .single();

        if (!profileError && profile) { // Directly await the query
          const typedProfile = profile as Profile;
          if (typedProfile?.role !== 'admin') {
            navigate('/dashboard');
            return;
          }
        } else {
          navigate('/dashboard');
          return;
        }

        setIsAdmin(true);
      } catch (error) {
        logger.error('Error checking admin status:', error);
        navigate('/login');
      } finally {
        setLoading(false);
      }
    }

    checkAdminStatus();
  }, [navigate]);

  return { isAdmin, loading };
}